import React, { useEffect } from 'react';

export default function AppTest() {

    useEffect(() => {
        const redirectToApp = () => {
            window.location.href = 'multiott://payment-success?transaction_id=T222222222';
        };

        // Optional delay so the success page can be displayed briefly
        const timer = setTimeout(() => {
            redirectToApp();
        }, 1000);

        return () => clearTimeout(timer);
    }, []);

    return (
        <div>
            <button
                style={{
                    backgroundColor: "navy",
                    color: "white",
                    padding: "10px",
                    borderRadius: "5px",
                    border: "none",
                    cursor: "pointer",
                    margin: "30px"
                }}
                onClick={() => {
                    window.location.href = 'multiott://payment-success?transaction_id=T111111111';
                }}>
                Open Multi OTT App
            </button>
        </div>
    );
}